<kodit-card-container>
  <div card-title>eOtpremnice</div>

  <div class="p-d-flex p-flex-column gap-8" card-body>
    <div class="p-d-flex p-ai-center gap-12">
      <p-inputSwitch
        inputId="pracenje-lagera-za-eotpremnice"
        [formControl]="pracenjeLageraCtrl"
        (onChange)="onPracenjeLageraChange($event.checked)"
      ></p-inputSwitch>
      <label for="pracenje-lagera-za-eotpremnice" kodit-form-label>
        Praćenje lagera za eOtpremnice
      </label>
    </div>
    <small *ngIf="hasVeleprodaja">
      Uz paket Veleprodaja praćenje lagera je uvek uključeno.
    </small>
    <small>
      Kada je uključeno, u meniju se prikazuje stanje lagera. eOtpremnice i
      ePrijemnice uvek umanjuju/uvećavaju stanje na lageru, pa se po uključivanju
      vide i ranije promene.
    </small>
  </div>
</kodit-card-container>
